import React from "react";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./filter.scss";
import FilterNewForDBSearch from "./FilterNewForDBSearch";

const style = {
  left: "366px",
  top: "51px",
  flexShrink: 0,
  overflow: "visible",
  paddingLeft: "10px",
};

export default function BasicDrawer({
  open,
  handleClose,
  filtersData,
  parameters,
  handleChangeFilter,
  handleAddFilter,
  handleRemoveFilter,
  handleClearAll,
  handleSearch,
  handleDrawerClose,
  clearFirstFilter,
}) {
  return (
    <div>
      <Drawer
        anchor="top"
        open={open}
        onClose={handleClose}
        className="serch-filter-d"
      >
        <Box sx={style}>
          <Box className="filter-main">
            <Typography variant="h6">Search Filters</Typography>
            <div>
              <IconButton onClick={() => handleDrawerClose()}>
                <CloseIcon />
              </IconButton>
            </div>
          </Box>
          <Divider className="divider1" />

          {filtersData?.map((item, index) => {
            return (
              <FilterNewForDBSearch
                index={index}
                filtersData={filtersData[index]}
                parameters={parameters}
                handleChangeFilter={handleChangeFilter}
                clearFirstFilter={clearFirstFilter}
                handleRemoveFilter={handleRemoveFilter}
              />
            );
          })}

          <Divider className="divider2" />

          <Grid container className="fliter-container" pb={1}>
            <Grid item>
              <Button
                variant="text"
                className="btn-search"
                onClick={handleAddFilter}
              >
                + Add Another Filter
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="btn-search"
                variant="text"
                onClick={handleClearAll}
              >
                Clear All
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="btn-search"
                variant="text"
                onClick={handleClose}
              >
                Proceed
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Drawer>
    </div>
  );
}
